import { defineMessages, FormattedMessage } from "react-intl";
import { MarimoIframeStatus } from "./MarimoIframe";
import { Progress, ProgressKind } from "@/kit/ui/progress";

export interface MarimoIframeStatusProgressProps {
  kind?: ProgressKind | undefined;
  status: MarimoIframeStatus;
  shift?: number | undefined;
  scale?: number | undefined;
}

export default function MarimoIframeStatusProgress({
  kind,
  status,
  shift = 0,
  scale = 1,
}: MarimoIframeStatusProgressProps) {
  const progress = Math.round(statusProgress[status] * scale + shift);
  return (
    <Progress kind={kind} value={progress}>
      <FormattedMessage {...labels[status]} />
    </Progress>
  );
}

const statusProgress: Readonly<Record<MarimoIframeStatus, number>> =
  Object.freeze({
    connecting: 0,
    running: 50,
    ready: 100,
  });

const labels = defineMessages<MarimoIframeStatus>({
  connecting: { defaultMessage: "Connecting notebook..." },
  running: { defaultMessage: "Running notebook..." },
  ready: { defaultMessage: "Ready!" },
});
